//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { CaretDownOutlined } from '@ant-design/icons';
import { Snackbar, Alert } from '@mui/material';
import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
//  -- Components ---------------------
import { Button, Modal, Tooltip } from '@mui/material';
import { MoreVert , DescriptionOutlined } from '@mui/icons-material';


import { Dropdown } from 'antd';
import EmptyState from 'components/EmptyState';
import Loading from 'components/Loading';
import { useLocation, useNavigate } from "react-router-dom";
import { handleChangeStatusActivity, handleDeleteClassActivity } from 'store/classActivities/thunks';
import { handleChangeStatusQuizzes, handleDeleteClassQuiz } from 'store/classQuizzes/thunks';
import { useCurrentOrgPermission, useParentOrgId } from 'store/organizations/selectors';
import { TableBg } from "utils/assets/images";
//  -- Constants ----------------------
import COLOR from 'utils/constants/color';

//  -- Features -----------------------
import GradeEditor from 'features/forms/GradeEditorStory';

//  -- Thunks -------------------------
import TooltipComp from 'components/Toottip';
import PasswordViewerModal from 'components/PasswordViewerModal';
import { debounce, filter, find, get, groupBy, has, isArray, uniqBy, orderBy, floor } from 'lodash';
import moment from "moment";
import { useCallback } from 'react';
import { useBookUnits } from "store/booksUnits/selectors";
import { useResources, useVideos } from 'store/resources/selectors';
import { useSchoologyAssignment } from "store/schoologyauth/selectors";
import { useStory } from "store/story/selectors";
import { handleListClassSubmissions, handleUpdateSubmission } from 'store/submissions/thunks';
import { handleListClassUsers } from 'store/userClasses/thunks';
import { handleGetUserPreference } from 'store/userPreference/thunks';
import { handleDeleteUserData } from 'store/users/thunks';
import { handleDeleteSchoologyAssignment, handleSyncAssignmentDataSchoology, handleSyncGradesToSchoology, handleSyncSchoologyClassesGrades} from "store/schoology/thunks"
import { getAssignmentLable, getStoryUrl, isVideo , generateUrlForNonEbook, checkIsDiffForUser } from 'utils/lib/ebookHelper';
import { checkHasAutoGrade, checkIsManualGradable, getCurrenSem, semeterDateByYear, getSem1EndDate } from "utils/methods/math";
import { BACK_TO_BOOK } from 'utils/config/reference';
import { openLoginInNewWindow  } from "store/keystore/thunks"
import * as Sentry from '@sentry/react';
import { useCurrentClassBook } from 'store/classes/selectors';
const rowOneColor = "#5f4c82"
const rowTwoColor = "#7b96d4"
const rowSemester = COLOR.OrangeExam
const rowThreeColor = "#7c458b"
const rowFourColor = COLOR.lightgreen

const getKey = (sem, year) => (`${sem == 1 ? "semester 1" : "semester 2"} - ${year}`)
const ACTIVE_BTN_COLOR = `linear-gradient(to bottom right, ${COLOR.indigo100} , ${COLOR.indigo300})`
const DEACTIVE_BTN_COLOR = `linear-gradient(to right, ${COLOR.lightseagreen100} , ${COLOR.lightseagreen200})`
const getBgColor = (isActive) => isActive ? ACTIVE_BTN_COLOR : DEACTIVE_BTN_COLOR
const getBgColorSemester = (isActive) => isActive ? ACTIVE_BTN_COLOR : rowSemester
const NAME_SHORTING = [{ key: "last_a_z", title: "Last Name, A-Z" }, { key: "last_z_a", title: "Last Name, Z-A" }, { key: "first_a_z", title: "First Name, A-Z" }, { key: "first_z_a", title: "First Name, Z-A" }]
const CELLARRAY_LENGTH = 15


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const CustomBtn = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    color: ${COLOR.black300};
    cursor: pointer;
    display: flex;
    justify-content: center;
    margin-right: 4px;
    outline: none;

    &:hover {
        color: ${COLOR.green100};
    }
`;

const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;


// border-right-color:${COLOR.black100}
const OverflowOne = styled.div`
    height: auto;
    display: inline-block;
    @media (max-width: 634px){
    
    }
`;
const OverflowTwo = styled.div`
    height: auto;
    display: inline-block;
    @media (max-width: 634px) {
       
    }
`;

const AssignmentDeleteWrapper = styled.div`
   cursor:pointer;
   margin-top: 5px;
   opacity:0;
`;

const TableCell = styled.div`
    text-align: center;
    align-items: center;
    background-color: ${p => !p.header && (p.active ? '#03989e82' : 'transparent')};
    color: ${p => p.header && (p.active ? COLOR.green100 : COLOR.black500)};
    display: flex;
    font-size: ${p => p.header && '11px'};
    font-weight: ${p => p.active ? 600 : 500};
    height: ${p => p.header ? '16px' : '48px'};
    justify-content: ${p => p.start ? 'flex-start' : 'center'};
    min-width: ${p => p.minWidth ? `${p.minWidth}px` : p.width};
    text-transform: ${p => p.header && 'uppercase'};
    transition: all 300ms ease;
    white-space: nowrap;
    width: ${p => p.width || '56px'};
    justify-content: center;
    overflow:hidden;
    &:first-child {
        justify-content: flex-start;
    }
    &:hover ${AssignmentDeleteWrapper} {
        opacity: ${p => p.disabled ? 0 : 1};
    }
`;


const TableCellSemester = styled.div`
    text-align: center;
    align-items: center;
    background-image: ${p => p.bgColor ? `linear-gradient(to right, ${p.bgColor} , ${p.bgColor})` : getBgColorSemester(p.active)};
    color: ${p => p.header && (p.active ? COLOR.green100 : COLOR.black500)};
    display: flex;
    font-size: ${p => p.header && '11px'};
    font-weight: ${p => p.active ? 600 : 500};
    height: ${p => p.header ? '16px' : '48px'};
    justify-content: ${p => p.start ? 'flex-start' : 'center'};
    min-width: ${p => p.minWidth ? `${p.minWidth}px` : p.width};
    text-transform: ${p => p.header && 'uppercase'};
    transition: all 300ms ease;
    white-space: nowrap;
    width: ${p => p.width || '56px'};
    justify-content: center;
    &:first-child {
        justify-content: flex-start;
    }
    &:hover ${AssignmentDeleteWrapper} {
        opacity: ${p => p.disabled ? 0 : 1};
    }
`;

const TableCellExam = styled.div`
    text-align: center;
    align-items: center;
    background-image: linear-gradient(90deg, ${COLOR.PinkExam} 0%, ${COLOR.OrangeExam} 100%); 
    color: ${p => p.header && (p.active ? COLOR.green100 : COLOR.black500)};
    display: flex;
    font-size: ${p => p.header && '11px'};
    font-weight: ${p => p.active ? 600 : 500};
    height: ${p => p.header ? '16px' : '48px'};
    justify-content: ${p => p.start ? 'flex-start' : 'center'};
    min-width: ${p => p.minWidth ? `${p.minWidth}px` : p.width};
    text-transform: ${p => p.header && 'uppercase'};
    transition: all 300ms ease;
    white-space: nowrap;
    width: ${p => p.width || '56px'};
    justify-content: center;
    &:first-child {
        justify-content: flex-start;
    }
    &:hover ${AssignmentDeleteWrapper} {
        opacity: ${p => p.disabled ? 0 : 1};
    }
`;

const TableCellEdit = styled.div`
    align-items: center;
    background-color: ${p => !p.header && (p.active ? '#03989e82' : 'transparent')};
    color: ${p => p.header && (p.active ? COLOR.green100 : COLOR.black500)};
    display: flex;
    font-size: ${p => p.header && '11px'};
    font-weight: ${p => p.active ? 600 : 500};
    height: ${p => p.header ? '16px' : '48px'};
    justify-content: ${p => p.start ? 'flex-start' : 'center'};
    min-width: ${p => p.minWidth ? `${p.minWidth}px` : p.width};
    text-transform: ${p => p.header && 'uppercase'};
    transition: all 300ms ease;
    white-space: nowrap;
    width: ${p => p.width || '56px'};

    &:first-child {
        justify-content: flex-start;
    }
    &:hover {
        color: white;
    }
`;
const AssignmentLabel = styled.button`
  border:none;
  background-color:transparent;
  width:100%;
  cursor:pointer;
  overflow:hidden;
`;
const OneLogoRow = styled.div`
  display: flex;
  flex-direction: row;
`;
const TableHeader = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
`;

const TableRow = styled.div`
    align-items: center;
    background-color: ${p => p.index % 2 === 0 ? '#40a9ff5e' : 'transparent'};
    border: 1px solid;
    color: ${COLOR.black200};
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
    width: auto;
`;

const Table = styled.div`
    padding-bottom: 0px;
`;


const Wrapper = styled.div`
    width: 100%;
`;
const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
`;
const TbgImgWrapper = styled.div`
    height: 69px;
    width: 100%;
    display: flex;
    justify-content: center;
`
const TbgImage = styled.img`
    width: 100%;
    height: 135%;
`
const Tab = styled.button`
    border: none;
    background-image: ${p => p.bgColor ? `linear-gradient(to right, ${p.bgColor} , ${p.bgColor})` : getBgColor(p.active)};
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px 0px;
    text-transform: uppercase;
    width: 150px;
    color: white;
    margin-right: 8px;
    border-radius: 3px;
`;
const TabExam = styled.button`
    border: none;
    background-image: linear-gradient(90deg, ${COLOR.PinkExam} 0%, ${COLOR.OrangeExam} 100%); 
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px 0px;
    text-transform: uppercase;
    width: 150px;
    color: white;
    margin-right: 8px;
    border-radius: 3px;
`;
const SyncTab = styled(Tab)`
    justify-self: flex-end;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content:center;
    margin-left:5px;
    margin-right:5px;
    height: 35px;
`;
const Row = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    width: 100%;
`;
const BookNameTitle = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width:100%;
  `;

const TbgContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 93px;
    background-color: ${COLOR.blueish100};
    border: 3px solid ${COLOR.indigo400};
    border-radius: 15px;
    padding: 16px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
    `
const TbgIconWrapper = styled.div`
  border-radius: 50%;
  overflow: hidden;
  width: 25px;
  height: 25px;
    `
const TbgIcon = styled.img`
    width: 30px;
    height: 30px;
    object-fit: cover;
    object-position: center;
    margin-left: -2.4px;
    margin-top: -2.5px;
}
    `
const OverviewIcon = styled.div`
    width: 20px;
    height: 20px;
    object-fit: cover;
    object-position: center;
    margin-left: -2.4px;
    margin-top: -2.5px;
    background-image: url(${p => p.src});
    background-position: center;
    background-size: 2880% 288%;
    background-repeat: no-repeat;
}
    `
const TbgTitle = styled.span`
    color: ${COLOR.white};
    font-size: 12px;
    font-weight: 600;
    margin-left: 8px;
    `
const TbgTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    margin-top: 8px;
    `
const TbgList = styled.ul`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-left: 14px;
`
const TbgListItem = styled.li`
    color: ${COLOR.white};
    font-size: 10px;
    font-weight: 400;
    `

const Logo = styled.img`
  width: 60px;
  border-radius: 50%;
`;
const OneWayText = styled.span`
  color: #424447;
  font-size: 16px;
  font-weight: 500;
  margin-left: 10px;
  text-transform: uppercase;
  line-height: 20px;
`;

const AssignmentTxt = styled.div`
    font-size: 14px;
    margin-left: 20px;
    font-weight: 600;
`;
const NameContent = styled.span`
    color: #fff;
    margin-left: 10px;
    width: 220px;

`;
const StudentNameTable = styled.div`
    display: flex;
    flex-direction: column;
    width: 230px;
    height:40px;
    padding-right: 20px;;
    `;
const QuestionTab = styled.span`
    color: #fff;
    font-size: 12px;
    background-color: rgb(128,161,90);
    width: 95%;
    height: 25px;
    padding-left: 10px;
    padding-top: 5px;
    border-radius: 5px;
`;
const StudentName = styled.span`
    color: #fff;
    font-size: 12px;
    background-color: rgb(89,118,243);
    width: 95%;
    height: 25px;
    padding-left: 10px;
    padding-top: 5px;
    border-radius: 5px;
`;
const HeaderTab = styled.div`
    height:25px;
    border:1px solid white;
    border-radious:5px;
    background-color:${COLOR.indigo100};
    color: white;
    text-align: center;
    margin-top: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding:0px 5px;
    padding: 3px 5px;
    display:flex;
    overflow: hidden;
`;
const HeaderTabP = styled.div`
    height:25px;
    border:1px solid white;
    border-radious:5px;
    background-color:rgb(11,9,84);
    color: white;
    text-align: center;
    margin-top: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    padding: 3px 5px;
    display:flex;
    overflow: hidden;
`;
const TableTopBtnCont = styled.div`
    justify-content: center;
    align-items: center;
    padding-left: 1.5%;
    overflow: hidden;
    display: flex;
    padding-left:5px;
    padding-right:5px;
`;
const TopTabCont = styled.div`
    display:flex;
    flex-direction:row;
`;
const TotalNStudentTxt = styled.span`
    font-size: 14px;
    font-weight: 600;
    margin-left: 10px;
    margin-top: 10px;
    white-space:pre-line;
    `;
const Exam2TableHeader = styled(TableHeader)`
    background-color:rgb(54,58,78);
    height:45px;
    border-radius:5px;
    align-items:center;
 

`;
const ChartContainer = styled.div`
    display:flex;
    flex-direction:row;
    width:100%;
    flex-wrap:wrap;
    @media (max-width: 992px) {
       width:100%;
      }
    
`;
const ChartContainerInner = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    height:50px;
    margin-left:10px;
    margin-right:10px;
`;
const ChartLabel = styled.span`
    font-size: 15px;
    font-weight: 600;
    margin-bottom: -20px;
`;
const SearchBox = styled.input`
  background-color: transparent;
  border: none;
  border-radius: 7px;
  color: ${COLOR.white};
  font-size: 14px;
  font-weight: 400;
  height: 30px;
  outline: none;
  padding: 2px 16px;
  width: 90%;
  margin-right: 2px;
  margin-left: 2px;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #fff;
  }
  :-ms-input-placeholder {
    color: #fff;
  }
  @media (max-width: 992px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
const SearchBoxContainer = styled.div`
    display: flex;
    flex-direction: row;
    border-radius: 5px;
    background-color:rgb(126,112,165);
    color: ${COLOR.green};
    font-size: 14px;
    align-items: center;
    width:100%;
    padding-right:12px;
    height: 30px;
    @media (max-width: 992px) {
       min-width:200px;
       margin-bottom:30px;
      }
`;
const ExamTableSection1 = styled.div`
    display: flex;
    flex-direction: column;
    width: 230px;
    margin-top:10px;
    `;
const ExamTableSection2 = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media (max-width: 992px) {
        width: 100%;
    }
    `;
const TableItem = styled.td`
    height:40px;
    width: 25%;
    border: 0.1px solid rgba(0,0,0,0.2);
    border-collapse: collapse;
    text-align:center;
    padding-top: 10px;
    `;
const ExamGradeTable = styled.table`
  border-collapse: collapse;
`;
const ExamRow = styled.tr`
    display: flex;
    flex-direction: row;`;
const PlacementText = styled.span`
       color:${p => p.textColor ? p.textColor : COLOR.gray100}
    `;
const GraphRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top:20px;
   @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    }

`;
const ExamOverflowTwo = styled(OverflowTwo)`
    width:90%;
    border-right: 0px;
    @media (max-width: 992px) {
        width:100%;
    }
    `;
const CloseBtn = styled.span`
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-left: 10px;
    margin-top: 10px;
    align-self: flex-end;
    display:flex;
    flex-direction:row;
    color:rgb(197,2,91);
    font-weight:bold;
    justify-content: flex-end;
    `;
const ExamGradeSec = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-image:url(${TableBg});
    padding:16px;
`;
const Rotate = styled.div`
  align-items: center;
  display: flex;
  height: 16px;
  justify-content: center;
  margin-right: 4px;
  transform: ${(p) => (p.open ? "rotate(90deg)" : "rotate(0deg)")};
  transition: all 300ms ease;
  width: 16px;
`;
const SortingMenu = styled.span`
  background-color: ${(p) => (p.active ? COLOR.indigo100 : COLOR.white)};
`;
const ChartPerText = styled.span`
    position: absolute;
    top: -10px;
    font-size: 11px;
`;
const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
const TableWrapper = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    border-right: none;
    margin-bottom: 52px;
    @media (max-width: 634px){
        width: 100%;
        overflow: scroll;
    }
`;
const TableWrapperInner2 = styled.div`
    overflow: scroll;
    overflow-y: hidden;
    @media (max-width: 634px){
        overflow: visible;
        
    }
    ::-webkit-scrollbar {
        width: 3px;
        height: 6px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: darkgrey;
        outline: 1px solid slategrey;
      }
`;
const AssignmentLabelText = styled.span`
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
`;
const NameText = styled.span`
width: 200px;
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
`;
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Gradebook
//
//  -- Description
//  District and class announcements
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  <Gradebook />
//



const sortname = (a, b) => {
    const nameA = a?.lastName?.toLowerCase()?.replace(/\s/g, '');
    const nameB = b?.lastName?.toLowerCase()?.replace(/\s/g, '');;
    if (nameA < nameB) { return -1 }
    else if (nameA > nameB) { return 1 }
    else { return 0 }
}
const SemesterToShow = (parentOrgId) => {
    const currentYear = moment().get("year");
    const lastYear = currentYear - 1;
    const semYearToShow = { sem1: '', sem2: '' }
    const currentSem = getCurrenSem(parentOrgId);
    const isSpecial = parentOrgId && ['e5dcb06f-f78d-457a-bacf-8fa357b38ee2', '37ae9554-0da4-4d62-b04f-ec500b0275a4'].includes(parentOrgId);
    
    if (isSpecial) {
        if (currentSem.includes("semester 1")) {
            const sem1Parts = currentSem.split(" - ");
            const sem1Year = sem1Parts[1];
            semYearToShow.sem1 = getKey(1, sem1Year);
            semYearToShow.sem2 = getKey(2, currentYear.toString());
        } else {
            semYearToShow.sem1 = getKey(1, lastYear.toString());
            semYearToShow.sem2 = getKey(2, currentYear.toString());
        }
    } else {
        const { sem1StartDate, sem1EndDate } = semeterDateByYear(currentYear, parentOrgId)
        if (moment().isSameOrAfter(sem1StartDate) && moment().isSameOrBefore(sem1EndDate)) {
            semYearToShow.sem1 = getKey(1, currentYear);
            semYearToShow.sem2 = getKey(2, currentYear);
        } else {
            semYearToShow.sem1 = getKey(1, lastYear);
            semYearToShow.sem2 = currentSem;
        }
    }
    return semYearToShow;

}
const getDefaultAssignmentData = (parentOrgId) => {
    const defaultAssignmentData = {}
    defaultAssignmentData[getCurrenSem(parentOrgId)] = new Array(CELLARRAY_LENGTH).fill({}, 0, CELLARRAY_LENGTH)
    return defaultAssignmentData
}
const GradeTable = ({
    currentClass,
    currentOrg,
    dataLoading,
    users,
    reviewAssignment,
    submissions,
    booksAllList,
    isReviewAccount,
    handleEditQuiz,
    handleEditActivity,
    currentUser,
    classActivities,
    classQuizzes,
    getAssignmentCreation,
    handleoverAllShow,
    handleGradeValueShow,
    userPreference = {},
}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const orgPermissions = useCurrentOrgPermission()
    const story = useStory()
    const parentOrgId = useParentOrgId();
    const currentSem = getCurrenSem(parentOrgId)
    const [index, setIndex] = useState(-1);
    const [open, setModalState] = useState(false);
    const [loginAsUserId,setLoginAsUserId] = useState(null);
    const [loginasLoader,setLoginasLoader] = useState(false);
    const [loginAsModal,setLoginAsModal] = useState(false);
    const [passwordViewerOpen, setPasswordViewerOpen] = useState(false);
    const [passwordViewerUser, setPasswordViewerUser] = useState(null);
    const [selectedUser, setSelectedUser] = useState({});
    const [semAssignment, setSemAssignment] = useState(() => getDefaultAssignmentData(parentOrgId));
    const [activeSemData, setActiveSemData] = useState(new Array(CELLARRAY_LENGTH).fill({}, 0, CELLARRAY_LENGTH));
    const scale_1_5 = userPreference?.gradePref == "scale_1_5"
    const gradebook_a_f = userPreference?.gradePref === "gradebook_a_f"
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [activeGradeTab, setActiveGradeTab] = useState("")
    const [filteredStudent, setFilteredStudent] = useState([])
    const [activeSem, setActiveSem] = useState(currentSem);
    const [isFlagMenuOpen, setFlagmenuOpen] = useState(false)
    const inputRefs = useRef([]);
    const activeCellIndexRefs = useRef(-1);
    const [activeIndex, setActiveIndex] = useState(-1);
    const isSchoologyUser = currentUser && currentUser.schoologyid ? true : false;
    const [listStudentUser, setListStudentUser] = useState(users && users.length > 0 ? filter(users, x => x.role === 'student' && x.active).sort(sortname) :  [])
    const [deleteClassAssignmentToggle, setDeleteClassAssignmentToggle] = useState(false);
    const [assignmentData, setAssignmentData] = useState(null)
    const [deleteAssignmentLoading, setSeleteAssignmentLoading] = useState(false);
    const [nameShortType, setNameShortType] = useState(NAME_SHORTING[0]);
    const videos = useVideos()
    const resources = useResources()
    const [openPop, setOpen] = React.useState(false);
    const [popupMessage, setPopupMessage] = React.useState('');
    const [schoologyAssignment, listSchoologyAssignment] = useSchoologyAssignment()
    const allowed_books = useCurrentClassBook();
    const sortByName = (a, b) => {
        const sortingFunctions = {
            [NAME_SHORTING[0].key]: (nameA, nameB) => nameA.localeCompare(nameB, 'en', { sensitivity: 'base' }),
            [NAME_SHORTING[1].key]: (nameA, nameB) => nameB.localeCompare(nameA, 'en', { sensitivity: 'base' }),
            [NAME_SHORTING[2].key]: (nameA, nameB) => nameA.localeCompare(nameB, 'en', { sensitivity: 'base' }),
            [NAME_SHORTING[3].key]: (nameA, nameB) => nameB.localeCompare(nameA, 'en', { sensitivity: 'base' }),
        };
    
        const getKey = (type) => {
            return (type === NAME_SHORTING[2].key || type === NAME_SHORTING[3].key) ? 'firstName' : 'lastName';
        };
    
        const key = getKey(nameShortType.key);
    
        const getNormalizedString = (obj, key) =>
            obj[key].toLowerCase().replace(/\s/g, "") +
            obj[key === "firstName" ? "lastName" : "firstName"]
                .toLowerCase()
                .replace(/\s/g, "");
    
        const nameA = getNormalizedString(a, key);
        const nameB = getNormalizedString(b, key);
    
        return sortingFunctions[nameShortType.key](nameA, nameB);
    };
    useEffect(() => {
        const allstudents = uniqBy(filter(users, x => x.role === 'student').sort(sortByName), "username");
        let arr = new Array(1).fill({}, 0, 1)
        setListStudentUser(allstudents.length > 0 ? allstudents : [])
        setFilteredStudent(allstudents.length > 0 ? allstudents : [])

    }, [users])
    useEffect(() => {
        setFilteredStudent(filteredStudent.sort(sortByName))
        setListStudentUser(listStudentUser.sort(sortByName))
        setTimeout(forceUpdate, 500)

    }, [nameShortType])

    useEffect(() => {
        const toShowSemObj = SemesterToShow(parentOrgId)
        if (classActivities && classQuizzes) {
            const uniqueActivity = uniqBy(classActivities, "activityId");
            const uniqueQuiz = uniqBy(classQuizzes, 'quizId');
            let _assignments = [...uniqueActivity, ...uniqueQuiz].filter(k => {
                const chapter = get(k, "data.bookId") || get(k, "data.chapter")
                return chapter?.length > 5 ? true : allowed_books.includes(chapter);
            })
            const _sortedssignment = _assignments
            const getDateField = (assignment) => {
                if (userPreference?.order_by_date === 'start_date') {
                    return assignment.scheduleAt;
                } else if (userPreference?.order_by_date === 'late_submission') {
                    return assignment.lateDate || assignment.dueDate;
                } else {
                    return assignment.dueDate;
                }
            };
            
            const isSpecial = parentOrgId && ['e5dcb06f-f78d-457a-bacf-8fa357b38ee2', '37ae9554-0da4-4d62-b04f-ec500b0275a4'].includes(parentOrgId);
            
            let yearData = groupBy(_sortedssignment, x => moment(getDateField(x)).format("YYYY"))
            const semData = {}
            Object.keys(yearData).map(year => {
                const yearNum = parseInt(year);
                let sem1StartDate, sem1EndDate, sem2StartDate, sem2EndDate;
                let sem1, sem2;
                
                if (isSpecial) {
                    const sem1Dates = semeterDateByYear(yearNum, parentOrgId);
                    const sem2Dates = semeterDateByYear(yearNum, parentOrgId);
                    sem1StartDate = sem1Dates.sem1StartDate;
                    sem1EndDate = sem1Dates.sem1EndDate;
                    sem2StartDate = sem2Dates.sem2StartDate;
                    sem2EndDate = sem2Dates.sem2EndDate;
                    
                    const prevYearSem1Dates = semeterDateByYear(yearNum - 1, parentOrgId);
                    const prevYearSem1StartDate = prevYearSem1Dates.sem1StartDate;
                    const prevYearSem1EndDate = prevYearSem1Dates.sem1EndDate;
                    
                    sem1 = yearData[year].filter(x => {
                        const assignmentDate = moment(getDateField(x));
                        const assignmentMonth = assignmentDate.month();
                        const assignmentDay = assignmentDate.date();
                        const sem1EndDay = getSem1EndDate(parentOrgId);
                        
                        if (assignmentMonth === 0 && assignmentDay <= sem1EndDay) {
                            return assignmentDate.isSameOrAfter(prevYearSem1StartDate, "day") && assignmentDate.isSameOrBefore(prevYearSem1EndDate, "day");
                        } else {
                            return assignmentDate.isSameOrAfter(sem1StartDate, "day") && assignmentDate.isSameOrBefore(sem1EndDate, "day");
                        }
                    }).sort((a, b) => new moment(getDateField(a)).format('YYYYMMDD') - new moment(getDateField(b)).format('YYYYMMDD'));
                    
                    sem2 = yearData[year].filter(x => {
                        const assignmentDate = moment(getDateField(x));
                        return assignmentDate.isSameOrAfter(sem2StartDate, "day") && assignmentDate.isSameOrBefore(sem2EndDate, "day");
                    }).sort((a, b) => new moment(getDateField(a)).format('YYYYMMDD') - new moment(getDateField(b)).format('YYYYMMDD'));
                } else {
                    const dates = semeterDateByYear(yearNum, parentOrgId);
                    sem1StartDate = dates.sem1StartDate;
                    sem1EndDate = dates.sem1EndDate;
                    sem2StartDate = dates.sem2StartDate;
                    sem2EndDate = dates.sem2EndDate;
                    
                    sem1 = yearData[year].filter(x => moment(getDateField(x)).isSameOrAfter(sem1StartDate, "day") && moment(getDateField(x)).isSameOrBefore(sem1EndDate, "day")).sort((a, b) => new moment(getDateField(a)).format('YYYYMMDD') - new moment(getDateField(b)).format('YYYYMMDD'));
                    sem2 = yearData[year].filter(x => moment(getDateField(x)).isSameOrAfter(sem2StartDate, "day") && moment(getDateField(x)).isSameOrBefore(sem2EndDate, "day")).sort((a, b) => new moment(getDateField(a)).format('YYYYMMDD') - new moment(getDateField(b)).format('YYYYMMDD'));
                }
                
                if (sem1.length < CELLARRAY_LENGTH) {
                    let len = CELLARRAY_LENGTH - sem1.length;
                    let arr = new Array(len).fill({}, 0, len)
                    sem1.push(...arr)
                }
                if (sem2.length < CELLARRAY_LENGTH) {
                    let len = CELLARRAY_LENGTH - sem2.length;
                    let arr = new Array(len).fill({}, 0, len)
                    sem2.push(...arr)
                }

                if (sem1.length > 0 || currentSem === getKey(1, year)) {
                    semData[getKey(1, year)] = sem1

                }
                if (sem2.length > 0 || currentSem === getKey(2, year)) {
                    semData[getKey(2, year)] = sem2
                }
            })
            if (semData[currentSem]) {
                setActiveSemData(semData[currentSem])
            } else {
                setActiveSemData(new Array(CELLARRAY_LENGTH).fill({}, 0, CELLARRAY_LENGTH))
                semData[currentSem] = new Array(CELLARRAY_LENGTH).fill({}, 0, CELLARRAY_LENGTH)
            }
            if (Object.keys(semData).length > 0) {
                const tempSemData = {}
                Object.keys(toShowSemObj).map(key => {
                    const dt = semData[toShowSemObj[key]];
                    tempSemData[toShowSemObj[key]] = isArray(dt) && dt.length > 0 ? dt : new Array(CELLARRAY_LENGTH).fill({}, 0, CELLARRAY_LENGTH)
                })
                setSemAssignment(tempSemData)
            }

        }
    }, [classActivities, classQuizzes, userPreference, parentOrgId]);
    useEffect(() => {
        getPref()
        getGradesFromScoology()
        getAssignmentFromSchoology()
    }, [classActivities, classQuizzes])
    const getPref = async () => {
        await dispatch(handleGetUserPreference(currentUser?.id));

    }


    const handleClose = () => {
        setOpen(false);
    };

    const updateSubmission = async (subm) => {
        if (!subm || !subm.userId) return;
        await dispatch(handleUpdateSubmission(subm?.id, subm, subm))
    }
    const getGradesFromScoology = debounce(async () => {
        try {
            if (currentClass?.sectionId) {
                await handleSyncSchoologyClassesGrades(currentUser.id, currentClass.id);
                // await handleSyncGradesToSchoology(currentUser.id, currentClass.id)
                await dispatch(handleListClassSubmissions(currentClass?.id))
            }

        } catch (error) {
            Sentry.captureException(`538 Error in getGradesFromScoology: ${error}`);
            console.log(error, "bid-err");
        }
    },1000)
    const location = useLocation();
  							  const navigate = useNavigate();
    const bookUnits = useBookUnits()
    const generateUrl = (CHAPTER_ID, page, activity, quiz) => {
        const storyUrl = getStoryUrl(story, CHAPTER_ID, page, quiz, activity)
        const backToLabel = BACK_TO_BOOK[CHAPTER_ID]
        const BALCON_PAGES = get(find(bookUnits, ["bookId", CHAPTER_ID]), "pages", [])
        const bookitem = find(BALCON_PAGES, k => parseInt(k.start) <= page && parseInt(k.finish) >= page)
        const url = generateUrlForNonEbook(bookitem?.id, page, activity, quiz, backToLabel, null, CHAPTER_ID)
        if (url && backToLabel) {
            return url;
        }
        else if (storyUrl) {
            return storyUrl;
        } else {
            return null;
        }
    } 
    const goToBook = (chapter, pageId) => {
        const generatedUrl = generateUrl(chapter, pageId, null, null)
        if (isVideo(chapter, resources)) {
            navigate(`/video?id=${chapter}&quiz=null`);
        } else if (generatedUrl) {
            navigate(generatedUrl);
        }
        else {
            navigate(`/ebook?chapter=${chapter}&page=${pageId}&activity=null&quiz=null`);
        }
    }
    const booknav = (assignment) => {
        const isActive = get(assignment, "active", true)
        const items = [
            {
                key: 'edit',
                label: (
                    <PaddedBtn onClick={() => {
                        if (assignment?.quizId) {
                            handleEditQuiz(assignment)
                        } else if (assignment.activityId) {
                            handleEditActivity(assignment)
                        }
                    }}>
                        Edit
                    </PaddedBtn>
                )
            },
            {
                key: 'goToBook',
                label: (
                    <PaddedBtn onClick={() => {
                        goToBook(get(assignment, "data.chapter"), get(assignment, "data.page"))
                    }}>
                        Go to book
                    </PaddedBtn>
                )
            },
            {
                key: 'delete',
                label: (
                    <PaddedBtn onClick={() => {
                        if (assignment && Object.keys(assignment).length > 0) {
                            setDeleteClassAssignmentToggle(true)
                            setAssignmentData(assignment)
                        }
                    }}>
                        Delete
                    </PaddedBtn>
                )
            },
            {
                key: 'activate',
                label: (
                    <PaddedBtn style={{ color: isActive ? COLOR.black : COLOR.red }}
                        onClick={() => {
                            if (get(assignment, "data.typeId") == "quiz" || get(assignment, "data.typeId") === "quizresource") {
                                activeDeactiveQuizzes(get(assignment, "id"), !isActive)
                            } else {
                                activeDeactiveActivites(get(assignment, "id"), !isActive)
                            }
                        }}>
                        {isActive ? "Deactivate" : "Activate"}
                    </PaddedBtn>
                )
            }
        ];

        return { items };
    };


    const activeDeactiveQuizzes = async (id, active) => {
        await dispatch(handleChangeStatusQuizzes(id, active))
    }
    const activeDeactiveActivites = async (id, active) => {
        await dispatch(handleChangeStatusActivity(id, active))

    }
    const getAssignmentFromSchoology =async () => {
        try {
            if (currentClass?.sectionId) {
                await handleSyncAssignmentDataSchoology(currentClass.id, currentUser.schoologyid)
            }
        } catch (error) {
            Sentry.captureException(`539 Error in getAssignmentFromSchoology: ${error}`);
            console.log(error, "bid-err");
        }
    }
    const checkSchoologyAssignment = (assignment) => {
        if (!assignment?.sAssignmentId) return null;
        const hasAssignment = find(schoologyAssignment, k => k.id == assignment?.sAssignmentId)
        return hasAssignment ? null : `Deleted from schoology!`
    }

    // if (students.length < 1) {
    //     let arr = new Array(1).fill({}, 0, 1)
    //     students.push(...arr)
    // }
    const studentSubmissions = groupBy(submissions, 'userId');
    const getWeightedGrade = (grade, weight) => {
        if (weight === 0) {
            return 0;
        }
        return (grade) * weight / 100;
    };
    const getWeightageFroQuiz = (assignment) => {
        return classQuizzes?.find(x => x.quizId === assignment.id)?.weightage
    }
    const getWeightageForActivity = (assignment) => {
        return classActivities?.find(x => x.activityId === assignment.id)?.weightage
    }
    const getWeightageForAssignment = useCallback((assignemnt) => {
        let weightage = 100;
        if (assignemnt.typeId === 'quiz') {
            let calculatedWeightage = getWeightageFroQuiz(assignemnt);
            if (!isNaN(calculatedWeightage) && calculatedWeightage > 0 && calculatedWeightage <= 100) {
                weightage = calculatedWeightage
            }
        } else {
            let calculatedWeightage = getWeightageForActivity(assignemnt);
            if (!isNaN(calculatedWeightage) && calculatedWeightage > 0 && calculatedWeightage <= 100) {
                weightage = calculatedWeightage
            }
        }
        return weightage;
    }, [classQuizzes, classActivities])

    const calculateValue = useMemo(() => (assignment, user) => {
        if (!user || !get(assignment, "data")) return ({ value: "--", isTbg: false, isLate: false, manualGrading: false, completeTbg: false })
        let isDiffStudent = false;
        if (Array.isArray(assignment.classes) && assignment.classes.length > 0) {
            const classConfig = find(assignment.classes, ['id', get(currentClass, "id")])
            isDiffStudent = checkIsDiffForUser(classConfig, user.id)
        }
        const hasAssigned = assignment.users == null || assignment.users.length == 0 || assignment.users.includes(user.id)
        const quize = find(studentSubmissions[user.id], ['assignmentId', get(assignment, "data.id")]);
        const retaking = get(quize, "retaking", false)
        // const bg_text = quize&&quize.ai_grade&&quize.ai_grade.length > 0?"TBG - AI": "TBG";
        const bg_text = "TBG - AI";
        let score = 0;
        const isTbg = checkIsManualGradable(get(quize, "assignment.questions", []))
        const isAllTab = !checkHasAutoGrade(get(quize, "assignment.questions", []))
        const isPartialTbg = isTbg && !isAllTab;
        const tbgTxt = isTbg ? bg_text : "-"
        const manualGrading = get(quize, "manualGrading")
        const face_grade =  get(quize, "face_grade")
        let grade = quize && quize.grade >= 0 ? quize.grade : null
        if (retaking && grade == 0) {
            grade = null
        }
        let value;
        if (isTbg && manualGrading && !isPartialTbg) {
            if (grade != null && (grade > 0 || grade == 0)) {
                value = grade 
            } else {
                value = tbgTxt
            }
        } else {
            value = grade != null ? grade : tbgTxt
        }
        if (quize?.submissions == 0 && (value === tbgTxt || value === bg_text)) {
            value = "-"
        }
        value = score > 0 ? score : value
        value = retaking && value == 0 ? "-" : value
        let isLate = false
        if (quize) {
            isLate = quize.isLate;
        }
        if (!isNaN(value) && scale_1_5) {
            let _g = value <= 0 ? 0 : floor((value - 1) / 20)
            value = `${_g > 4 ? 4 : _g}`
        }
        else if (!isNaN(value) && gradebook_a_f) {
            const g = parseInt(value)
            if (g <= 20 && g >= 0) {
                value = 'F';
            }
            else if (g <= 40 && g >= 21) {
                value = 'D';
            }
            else if (g <= 60 && g >= 41) {
                value = 'C';
            }
            else if (g <= 80 && g >= 61) {
                value = 'B';
            }
            else if (g >= 80) {
                value = 'A';
            } else {
                value = '-'
            }
        }
        else {
            value = `${value}`
        }
        return { value, isTbg, isLate, isDiffStudent, manualGrading: manualGrading, completeTbg: isAllTab, hasAssigned, face_grade }
    });

    const userNav = (user) => {
        const items = [
            {
                key: 'loginAs',
                label: (
                    <div onClick={() => {
                        if(user&&user.id){
                            setLoginAsUserId(user.id)
                            setLoginAsModal(true);
                        }
                    }}>
                        Login as
                    </div>
                )
            },
            {
                key: 'viewPassword',
                label: (
                    <div onClick={() => {
                        setPasswordViewerUser(user);
                        setPasswordViewerOpen(true);
                    }}>
                        View username and  password
                    </div>
                )
            }
        ];

        return { items };
    };

    const sortingNav = (user) => {
        const items = NAME_SHORTING.map(item => ({
            key: item.title,
            label: (
                <div onClick={() => {
                    setNameShortType(item)
                }} style={{ backgroundColor: item.key == nameShortType.key ? COLOR.indigo600 : "#fff", color: item.key == nameShortType.key ? COLOR.white : COLOR.gray100 }}>
                    {item.title}
                </div>
            )
        }));

        return { items };
    };

    const getCellStyle = (isLate, isDiffStudent, isTbg) => {
        if (isLate) {
            return ({ backgroundColor: "rgba(255,0,0,0.2)" })
        } else if (isDiffStudent) {
            return ({ backgroundColor: "#00ff134f" })
        }
        else {
            return ({})
        }
    }
    const removeUser = async () => {
        setLoading(true);
        const orgId = currentOrg.parentId !== 'null' ? currentOrg.parentId : currentOrg?.id;
        await dispatch(handleDeleteUserData(selectedUser.id, selectedUser.username, orgId, currentClass.id));
        await dispatch(handleListClassUsers(currentClass.id));
        setSelectedUser({});
        setLoading(false);
        setModalState(false);
    };

    const deleteAssignment = async (e) => {
        e.preventDefault();
        setSeleteAssignmentLoading(true);
        try {
            if (assignmentData && assignmentData?.quizId) {
                await dispatch(handleDeleteClassQuiz(
                    assignmentData.quizId,
                    assignmentData.classId
                ));
            } else if (assignmentData && assignmentData.activityId) {
                await dispatch(handleDeleteClassActivity(
                    assignmentData.activityId,
                    assignmentData.classId
                ));
            }

            if (assignmentData && assignmentData.sAssignmentId && assignmentData.sAssignmentId.length > 0 && currentClass.sectionId) {
                await handleDeleteSchoologyAssignment(currentClass.sectionId,currentUser.schoologyid,assignmentData.sAssignmentId)
                listSchoologyAssignment(currentClass.sectionId)
            }
            onDeleteSuccess()
        } catch (error) {
            Sentry.captureException(`540 Error in deleteAssignment: ${error}`);
            onDeleteSuccess()
        }

    };
    const onDeleteSuccess = () => {
        setDeleteClassAssignmentToggle(false);
        setSeleteAssignmentLoading(false)
        setAssignmentData(null)
    }
    const loginAsStudent = async ()=>{
        setLoginasLoader(true);
        await openLoginInNewWindow(loginAsUserId);
        setLoginasLoader(false);
        setLoginAsModal(false);
   }
    const isEditable = useCallback(() => {
        return false;
    }, [])
    const orderedActiveSemData = useMemo(() => {
        let val;
        if (userPreference?.order_by_date === 'due_date') {
            val = orderBy(filter(activeSemData, k => k?.dueDate), [(item) => new Date(item?.dueDate)], [userPreference?.orderBy])
            val.push(...filter(activeSemData, k => !k?.dueDate))
        } else if (userPreference?.order_by_date === 'late_submission') {
            val = orderBy(filter(activeSemData, k => k?.lateDate || k?.dueDate), [(item) => new Date(item?.lateDate || item?.dueDate)], [userPreference?.orderBy])
            val.push(...filter(activeSemData, k => !k?.lateDate && !k?.dueDate))
        } else {
            val = orderBy(filter(activeSemData, k => k?.scheduleAt), [(item) => new Date(item?.scheduleAt)], [userPreference?.orderBy])
            val.push(...filter(activeSemData, k => !k?.scheduleAt))
        }
        return val;
    }, [activeSemData,userPreference])

    const checkAssignmentByOrder = useCallback((assignment) => {
        if (userPreference?.order_by_date === 'due_date') {
            return assignment?.dueDate ? <span>{`${moment(assignment?.dueDate).format("MMM DD")}`}</span> : <span></span>
        } else if (userPreference?.order_by_date === 'late_submission') {
            const dateToShow = assignment?.lateDate || assignment?.dueDate;
            return dateToShow ? <span>{`${moment(dateToShow).format("MMM DD")}`}</span> : <span></span>
        }else{
            return assignment?.scheduleAt ? <span>{`${moment(assignment?.scheduleAt).format("MMM DD")}`}</span> : <span></span>
        }

    },[userPreference,orderedActiveSemData])
    
    const numRows = useMemo(() => listStudentUser.length, [listStudentUser]);
    const numCols = useMemo(() => orderedActiveSemData.length, [orderedActiveSemData]);
    
    const onFousInput = (index) => {
        onBlurInput()
        const inputRef = inputRefs.current[index];
        if (inputRef && inputRef.ref) {
            inputRef.ref.focus();
        }
    }
    
    const onBlurInput = () => {
        if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
        }
    }
    
    const enterKeyListner = useCallback(debounce(() => {
        try {
            const hasref = inputRefs.current.find(e => e && e.ref == document.activeElement)
            const active_index = activeCellIndexRefs.current;
            const currentInput = inputRefs.current[active_index]
            if (hasref) {
                if (active_index < numRows * numCols - numCols) {
                    onBlurInput()
                    setActiveIndex(active_index + numCols);
                } else {
                    onBlurInput()
                }
            } else {
                if (currentInput && currentInput.ref && currentInput.ref.disabled) {
                    if (active_index < numRows * numCols - numCols) {
                        setActiveIndex(active_index + numCols);
                    }
                } else {
                    onFousInput(active_index);
                }
            }  
        } catch (error) {
            Sentry.captureException(`Error in enterKeyListner: ${error}`);
        }
    }, 100), [numRows, numCols])
    
    const handleKeyDown = useCallback(
        (e) => {
            let debateInput = document.getElementsByClassName("left-right-disabled").length > 0;
            if(document.querySelector('.ant-drawer-open')||document.querySelector('.one_game_open') || debateInput) return;
            const { key } = e;
            const row = Math.floor(activeIndex / numCols);
            const StartRow = row * numCols;
            const EndRow = StartRow + numCols;
            switch (key) {
                case "ArrowUp":
                case 38:
                    if (activeIndex / numCols >= 1) {
                        onBlurInput()
                        setActiveIndex(activeIndex - numCols);
                    }
                    break;
                case "ArrowDown":
                case 40:
                    if (activeIndex < numRows * numCols - numCols) {
                        onBlurInput()
                        setActiveIndex(activeIndex + numCols);
                    }
                    break;
                case "ArrowRight":
                case 39:
                    if (activeIndex < (EndRow-1)) {
                        setActiveIndex(activeIndex + 1);
                        onBlurInput()
                    }
                    break;
                case "ArrowLeft":
                case 37:
                    if (activeIndex > StartRow) {
                        setActiveIndex(activeIndex - 1);
                        onBlurInput()
                    }
                    break;
                case "Enter":
                case 13:
                    enterKeyListner()
                    break;
                case "Escape":
                    onBlurInput()
                    break;
                default:
                    break;
            }
        },
        [activeIndex, numRows, numCols, enterKeyListner]
    );
    
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleKeyDown]);
    
    useEffect(() => {
        activeCellIndexRefs.current = activeIndex;
        if (activeIndex >= 0) {
            onFousInput(activeIndex);
        }
    }, [activeIndex]);
    
    return (
        <Wrapper>
              <Modal
                open={loginAsModal}
                onClose={() => setLoginAsModal(false)}
            >
                <ModalContent>
                       You will login as your student, any changes you make will be APPLIED to this account.
                    <ModalRow>
                        <Button
                          color="secondary"
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setLoginAsModal(false)
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={loginAsStudent}
                        >
                            {loginasLoader ? <Loading size={20} white /> : 'Login as Student'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openPop}
                autoHideDuration={3000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
            <Modal
                open={open}
                onClose={() => setModalState(false)}
            >
                <ModalContent>
                    Are you sure you want to remove this student? All information and assignment submissions will be deleted.
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setModalState(false)
                                setSelectedUser({})
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={removeUser}
                        >
                            {loading ? <Loading size={20} white /> : 'Remove'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <PasswordViewerModal
                open={passwordViewerOpen}
                user={passwordViewerUser}
                onClose={() => {
                    setPasswordViewerOpen(false);
                    setPasswordViewerUser(null);
                }}
            />
            <Modal
                open={deleteClassAssignmentToggle}
                onClose={() => setDeleteClassAssignmentToggle(false)}
            >
                <ModalContent>
                    Are you sure you want to delete the assignment? All grades will be removed as well.
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => onDeleteSuccess()}
                            disabled={deleteAssignmentLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={(e) => deleteAssignmentLoading ? null : deleteAssignment(e)}
                            className={`${deleteAssignmentLoading ? "disabled-button" : ""}`}
                        >
                            {deleteAssignmentLoading ? <Loading size={20} white /> : 'Yes'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            {dataLoading ? (
                <Loading />
            ) : (
                <div>
                    {activeGradeTab == "" &&
                        <>
                            <TableWrapper className="orgTableData">
                                <OverflowOne>
                                    <Table>
                                        <TableHeader style={{ paddingBottom: 0, marginBottom: 1 }}>
                                            <TableCellExam header="true" width='286px' style={{ backgroundColor: rowOneColor, color: 'white', height: '30px', fontSize: '12px', fontWeight: 'bold', borderRight: '1px solid white', cursor: 'pointer', justifyContent: "center", backgroundImage: "none" }}>
                                                Name of story
                                            </TableCellExam>
                                        </TableHeader>
                                        <TableHeader style={{ paddingBottom: 0, marginBottom: 1 }}>
                                            <TableCellSemester header="true" width='286px' style={{ backgroundColor: rowTwoColor, color: 'white', height: '30px', fontSize: '12px', fontWeight: 'bold', borderRight: '1px solid white', justifyContent: "center" }}>
                                                Page Number:
                                            </TableCellSemester>
                                        </TableHeader>
                                        <TableHeader style={{}}>
                                            <Dropdown menu={sortingNav()} trigger={['click']}>
                                                <TableCell header="true" width='286px' style={{ backgroundColor: rowThreeColor, color: 'white', height: '30px', fontSize: '12px', fontWeight: 'bold', borderRight: '1px solid white', cursor: 'pointer', justifyContent: "center" }}>
                                                    <div>
                                                        {nameShortType.title}
                                                    </div>
                                                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                </TableCell>
                                            </Dropdown>
                                        </TableHeader>
                                        <TableHeader style={{ }}>
                                            <TableCellSemester header="true" width='286px' style={{ backgroundColor: rowFourColor, color: COLOR.black400 , height: '30px', fontSize: '12px', fontWeight: 'bold', borderRight: '1px solid white', justifyContent: "center" }}>
                                                Number of questions:
                                            </TableCellSemester>
                                        </TableHeader>
                                        {listStudentUser.length === 0 ? (
                                                <EmptyState message="Currently 0 students enrolled in this class." from="story" />
                                            ) : (
                                        <>
                                                {listStudentUser.length > 0 && listStudentUser.map((user, i) => (
                                            <TableRow key={user?.id ?? i + "user"} index={i + 1} style={{ borderRight: '0px' }}>
                                                <TableCell width='100%' style={!user?.userclass?.active ? { color: COLOR.radish100 } : {}}>
                                                    <Dropdown menu={userNav(user)} disabled={isReviewAccount || Object.keys(user ?? {}).length == 0} placement="bottomLeft" trigger={['click']}>
                                                        <CustomBtn onClick={e => e.preventDefault()}>
                                                            <MoreVert />
                                                        </CustomBtn>
                                                    </Dropdown>
                                                    <NameText>
                                                    {user.lastName}, {user.firstName}
                                                    </NameText>
                                                    <CustomBtn
                                                        onClick={e => e.preventDefault()}>
                                                        <DescriptionOutlined style={{}} onClick={() => {
                                                            handleoverAllShow(user);
                                                        }} />
                                                    </CustomBtn>

                                                </TableCell>
                                            </TableRow>
                                                ))}
                                                
                                        </>)}
                                        
                                    </Table>
                                </OverflowOne>
                                <TableWrapperInner2>
                                    <OverflowTwo >
                                        <Table>
                                            <TableHeader style={{ paddingBottom: 0, marginBottom: 1 }}>
                                                {orderedActiveSemData?.map((assignment, i) => {
                                                    return (<span key={i + "assignment"}>
                                                        <TableCell
                                                            style={{ backgroundColor: rowOneColor, color: 'white', height: '30px', fontSize: '10px', fontWeight: 'bold', borderRight: '1px solid white', paddingLeft: 4, paddingRight: 4 }}
                                                            key={assignment?.id + i}
                                                            active={index === i}
                                                            id={assignment?.id}
                                                            onMouseEnter={() => setIndex(i)}
                                                            onMouseLeave={() => setIndex(-1)}
                                                            header="true"
                                                            minWidth={96}
                                                            width="150px"
                                                        >
                                                            <Tooltip title={get(assignment,"displayName")}><AssignmentLabelText>
                                                            <BookNameTitle>{get(assignment,"displayName")}</BookNameTitle>
                                                                </AssignmentLabelText>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </span>)
                                                })}
                                            </TableHeader>
                                            <TableHeader style={{ paddingBottom: 0, marginBottom: 1 }}>
                                                {orderedActiveSemData?.map((assignment, i) => {
                                                    const isActive = get(assignment, "active", true)
                                                    return (<span key={i + "assignment"}>
                                                        <Dropdown menu={booknav(assignment)} disabled={!get(assignment, "id")} placement="bottomRight" trigger={['click']}>
                                                            <TableCell
                                                                style={{ backgroundColor: !isActive ? COLOR.redishpink : rowTwoColor, color: 'white', height: '30px', fontSize: '12px', fontWeight: 'bold', borderRight: '1px solid white', cursor: 'pointer', justifyContent: "center" }}
                                                                key={assignment?.id}
                                                                active={index === i}
                                                                id={assignment?.id}
                                                                onMouseEnter={() => setIndex(i)}
                                                                onMouseLeave={() => setIndex(-1)}
                                                                header="true"
                                                                minWidth={96}
                                                                width="150px"
                                                            >
                                                                <Tooltip title={get(assignment, "displayName", get(assignment, "data.displayName", ""))}>
                                                                    <AssignmentLabelText>{getAssignmentLable(assignment, booksAllList, videos, resources)}</AssignmentLabelText>
                                                                </Tooltip>
                                                                <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                            </TableCell>
                                                        </Dropdown>
                                                    </span>)
                                                })}
                                            </TableHeader>
                                            <TableHeader style={{}}>
                                                {orderedActiveSemData?.map((assignment, i) => (
                                                    <span key={`${i} assignment`}>
                                                        <TableCell
                                                            style={{ backgroundColor: rowThreeColor, color: 'white', height: '30px', fontSize: '12px', fontWeight: 'bold', borderRight: '1px solid white', textAlign: "center", justifyContent: "center" }}
                                                            key={`${assignment?.id} - ${i}`}
                                                            active={index === i}
                                                            id={assignment?.id}
                                                            onMouseEnter={() => setIndex(i)}
                                                            onMouseLeave={() => setIndex(-1)}
                                                            minWidth={96}
                                                            width="150px"
                                                        > 
                                                        {checkAssignmentByOrder(assignment)}
                                                        
                                                            {/* {assignment?.dueDate ? <span>{`${moment(assignment?.dueDate).format("MMM DD")}`}</span> : <span></span>} */}
                                                        </TableCell>
                                                    </span>
                                                ))}
                                            </TableHeader>
                                            <TableHeader style={{}}>
                                                {orderedActiveSemData?.map((assignment, i) => (
                                                    <span key={`${i} assignment`}>
                                                        <TableCell
                                                            style={{ backgroundColor: rowFourColor, color: COLOR.black400, height: '30px', fontSize: '12px', fontWeight: 'bold', borderRight: '1px solid white', textAlign: "center", justifyContent: "center" }}
                                                            key={`${assignment?.id} - ${i}`}
                                                            active={index === i}
                                                            id={assignment?.id}
                                                            onMouseEnter={() => setIndex(i)}
                                                            onMouseLeave={() => setIndex(-1)}
                                                            minWidth={96}
                                                            width="150px"
                                                        >
                                                            {get(assignment, "data.questions.length", '-')}
                                                        </TableCell>
                                                    </span>
                                                ))}
                                            </TableHeader>
                                            {listStudentUser.length === 0 ? (
                                                <EmptyState message="Currently 0 students enrolled in this class." from="story" />
                                            ) : (
                                                <>
                                                    {listStudentUser.map((user, i) => (
                                                        <TableRow key={user?.id ?? i + "user"} index={i + 1} style={{ borderLeft: '0px' }}>
                                                            {orderedActiveSemData?.map((assignment, j) => {
                                                                const { value, isTbg, isLate, isDiffStudent, manualGrading, completeTbg, hasAssigned, face_grade } = calculateValue(assignment, user)
                                                                const tempData = getAssignmentCreation(assignment, user)
                                                                const ungraded = get(assignment,"ungraded",false)
                                                                const index = i * numCols + j;
                                                                return (
                                                                    <TooltipComp
                                                                        hasToolTip={isTbg}
                                                                        hideVisability={isFlagMenuOpen}
                                                                        title={isTbg ? "This includes open-ended questions." : ""}
                                                                        key={j + "tooltip"} >
                                                                        <TableCellEdit
                                                                            style={getCellStyle(isLate, isDiffStudent, isTbg)}
                                                                            key={assignment?.id ?? (j + "tcell")}
                                                                            active={activeIndex === index}
                                                                            onMouseEnter={() => setIndex(j)}
                                                                            onMouseLeave={() => setIndex(-1)}
                                                                            minWidth={96}
                                                                            width="150px"
                                                                        >
                                                                            <GradeEditor
                                                                                disabled={isEditable() || !hasAssigned || (typeof user?.userclass?.active == "boolean" ? !user?.userclass?.active : false) || !assignment?.data?.id}
                                                                                assignmentId={assignment?.id ?? (j + "assignment")}
                                                                                isReviewAccount={isReviewAccount}
                                                                                data={find(studentSubmissions[user?.id], ['assignmentId', assignment?.data?.id])}
                                                                                reviewAssignment={(v) => { reviewAssignment(v, tempData, listStudentUser, studentSubmissions) }}
                                                                                tempData={tempData}
                                                                                submission={find(studentSubmissions[user.id], ['assignmentId', assignment?.data?.id])}
                                                                                userId={user?.id ?? (j + "userr")}
                                                                                value={hasAssigned ? value.toUpperCase() : "N/A"}
                                                                                scale_1_5={scale_1_5}
                                                                                gradebook_a_f={gradebook_a_f}
                                                                                assignments={assignment}
                                                                                currentClass={currentClass}
                                                                                user={user}
                                                                                assignment={assignment}
                                                                                handleGradeValueShow={handleGradeValueShow}
                                                                                isTbg={isTbg && manualGrading}
                                                                                ungraded={ungraded}
                                                                                studentSubmissions={studentSubmissions[user.id]}
                                                                                onFlagMenuViewChange={(visiblity) => {
                                                                                    setFlagmenuOpen(visiblity)
                                                                                }}
                                                                                currentUser={currentUser}
                                                                                face_grade={face_grade}
                                                                                enterKeyListner={enterKeyListner}
                                                                                ref={(el) => {
                                                                                    if (el) {
                                                                                        inputRefs.current[index] = el;
                                                                                    }
                                                                                }}
                                                                                onFocus={() => {
                                                                                    setActiveIndex(index)
                                                                                }}
                                                                                onBlur={() => { }}
                                                                            />

                                                                        </TableCellEdit>
                                                                    </TooltipComp>
                                                                )
                                                            })}
                                                        </TableRow>
                                                    ))}
                                                </>
                                            )}
                                        </Table>
                                    </OverflowTwo>
                                </TableWrapperInner2>
                            </TableWrapper></>}
                </div>
            )}
        </Wrapper>
    );
};


export default GradeTable;
